import {
  LOAD_INITIAL_DATA_REQUEST,
  LOAD_INITIAL_DATA_SUCCESS,
  LOAD_ROUTES_REQUEST,
  LOAD_ROUTES_SUCCESS,
  ROUTING_LIST,
  SET_FILTERS,
  SET_LOADING_CLIENTS,
  SET_LOADING_REPORT,
  SET_LOADING_SAVE,
  SET_LOADING_AI_SETTINGS,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  SEARCH,
  SET_WALLET_SUMMARY,
  SAVE_AI_ROUTE_SETTINGS_REQUEST,
  SAVE_AI_ROUTE_SETTINGS_SUCCESS,
  START_AI_ROUTE_JOB,
  UPDATE_AI_ROUTE_JOB,
  CLEAR_AI_ROUTE_JOB
} from './routing-constants';
import { RoutingListState, RoutingState, WalletSummary } from './routing-interfaces';

const INITIAL_LIST: RoutingListState = {
  allRows: [],
  rows: [],
  rowsCount: 0,
  page: 0,
  rowsPerPage: 10,
  rowsPerPageOptions: [10, 25, 50, 100],
  selected: [],
  order: 'asc',
  orderBy: 'name',
  searchText: ''
};

const INITIAL_STATE: RoutingState = {
  loadingClients: false,
  loadingSave: false,
  loadingAiSettings: false,
  loadingReport: false,
  clients: [],
  allocations: [],
  cityLocales: [],
  reportMetrics: [],
  walletSummary: null,
  aiSettingsSavedFor: null,
  aiRouteJob: null,
  listType: ROUTING_LIST.MANUAL,
  filters: {
    seller: null,
    state: null,
    city: null,
    neighborhood: null,
    week: 1,
    dayOfWeek: null
  },
  list: { ...INITIAL_LIST }
};

export default function routingReducer(state = INITIAL_STATE, action: any): RoutingState {
  switch (action.type) {
    case LOAD_INITIAL_DATA_REQUEST:
    case SAVE_AI_ROUTE_SETTINGS_REQUEST:
      return { ...state, aiSettingsSavedFor: null };

    case SAVE_AI_ROUTE_SETTINGS_SUCCESS:
      return { ...state, aiSettingsSavedFor: action.userExternalCode };

    case START_AI_ROUTE_JOB:
      return { ...state, aiRouteJob: action.job };

    case UPDATE_AI_ROUTE_JOB:
      return state.aiRouteJob ? { ...state, aiRouteJob: { ...state.aiRouteJob, ...action.job } } : state;

    case CLEAR_AI_ROUTE_JOB:
      return { ...state, aiRouteJob: null };

    case SET_LOADING_CLIENTS:
      return { ...state, loadingClients: action.loading };

    case SET_LOADING_SAVE:
      return { ...state, loadingSave: action.loading };

    case SET_LOADING_AI_SETTINGS:
      return { ...state, loadingAiSettings: action.loading };

    case SET_LOADING_REPORT:
      return { ...state, loadingReport: action.loading };

    case SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters
        }
      };

    case LOAD_INITIAL_DATA_SUCCESS: {
      return {
        ...state,
        clients: action.payload.clients,
        cityLocales: action.payload.cityLocales,
        allocations: action.payload.allocations || [],
        list: {
          ...INITIAL_LIST,
          rowsPerPage: state.list.rowsPerPage,
          rowsPerPageOptions: state.list.rowsPerPageOptions,
          searchText: state.list.searchText,
          allRows: [],
          rows: [],
          rowsCount: 0
        }
      };
    }

    case LOAD_ROUTES_REQUEST: {
      const listType = action.typeList ?? state.listType;
      if (listType === state.listType) return state;

      return {
        ...state,
        listType,
        list: { ...state.list, page: 0, allRows: [], rows: [], rowsCount: 0 }
      };
    }

    case LOAD_ROUTES_SUCCESS: {
      return {
        ...state,
        list: {
          ...INITIAL_LIST,
          rowsPerPage: state.list.rowsPerPage,
          rowsPerPageOptions: state.list.rowsPerPageOptions,
          searchText: state.list.searchText,
          page: state.list.page,
          allRows: action.payload.data,
          rows: action.payload.data,
          rowsCount: action.payload.count
        }
      };
    }

    case SET_PAGE:
      return {
        ...state,
        list: { ...state.list, page: action.page }
      };

    case SET_ROWS_PER_PAGE:
      return {
        ...state,
        list: { ...state.list, rowsPerPage: action.rowsPerPage }
      };

    case SET_ORDER:
      return {
        ...state,
        list: { ...state.list, order: action.order }
      };

    case SET_ORDERBY:
      return {
        ...state,
        list: { ...state.list, orderBy: action.orderBy }
      };

    case SEARCH: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: [...state?.list?.allRows],
          rowsCount: state?.list?.allRows?.length
        }
      };
    }
    case SET_WALLET_SUMMARY:
      return { ...state, walletSummary: action.walletSummary };

    default:
      return state;
  }
}
